// Groups sign-up, sign-in, and password workflows behind a credentials-focused auth application boundary.
import type { AuthCredentialsPort, PasswordResetInput, SignInInput, SignUpInput, UpdatePasswordInput } from '../core/types';

export function createAuthCredentialsService(port: AuthCredentialsPort) {
  return {
    signUp(input: SignUpInput) {
      return port.signUp(input);
    },
    signIn(input: SignInInput) {
      return port.signIn(input);
    },
    requestPasswordReset(input: PasswordResetInput) {
      return port.requestPasswordReset(input);
    },
    updatePassword(input: UpdatePasswordInput) {
      return port.updatePassword(input);
    },
  };
}
